"use strict";
/**
 * UI Constants
 *
 * Centralized constants for UI behavior across the application.
 * Includes timing values, thresholds, and other UI-related configuration.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOVER_DELAY_MS = void 0;
/**
 * Hover interaction delays
 */
exports.HOVER_DELAY_MS = 200;
